import './App.css';
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Hakkimizda from "./pages/Hakkimizda";
import Silivri from "./pages/seo/Silivri";
import SirketKurulusu from "./pages/hizmetler/SirketKurulusu";
import MuhasebeHizmetleri from "./pages/hizmetler/Muhasebe";
import MaliDanismanlik from "./pages/hizmetler/MaliDanismanlik";
import Bordrolama from "./pages/hizmetler/Bordrolama";
import YonetimDenetim from "./pages/hizmetler/YonetimDenetim";
import TesvikHibeDanismanlik from "./pages/hizmetler/TesvikHibeDanismanlik";
import ETicaretSatisMuhasebesi from "./pages/hizmetler/ETicaretSatisMuhasebesi";
import Iletisim from "./pages/Iletisim";
import Mevzuat from "./pages/bilgi/Mevzuat";
import AsgariUcret from "./pages/bilgi/AsgariUcret";
import KdvOranlari from "./pages/bilgi/KdvOranlari";
import Corlu from "./pages/seo/Corlu";
import Cerkezkoy from "./pages/seo/Cerkezkoy";
import Selimpasa from "./pages/seo/Selimpasa";
import TurmobNews from "./pages/news/TurmobNews";
import GibNews from "./pages/news/GibNews";

function App() {
    return (
        <Router>
            <Navbar />
            <main className="container mx-auto p-4">
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/hakkimizda" element={<Hakkimizda />} />
                    <Route path="/silivri-serbest-muhasebeci-mali-musavir-smmm" element={<Silivri />} />
                    <Route path="/corlu-serbest-muhasebeci-mali-musavir-smmm" element={<Corlu />} />
                    <Route path="/cerkezkoy-serbest-muhasebeci-mali-musavir-smmm" element={<Cerkezkoy />} />
                    <Route path="/selimpasa-serbest-muhasebeci-mali-musavir-smmm" element={<Selimpasa />} />
                    <Route path="/hizmetler/sirket-kurulus-hizmetleri" element={<SirketKurulusu />} />
                    <Route path="/hizmetler/muhasebe-ve-mali-musavirlik-hizmetleri" element={<MuhasebeHizmetleri />} />
                    <Route path="/hizmetler/mali-danismanlik-hizmetleri" element={<MaliDanismanlik />} />
                    <Route path="/hizmetler/bordrolama-ve-personel-hizmetleri" element={<Bordrolama />} />
                    <Route path="/hizmetler/yonetim-ve-denetim-hizmetleri" element={<YonetimDenetim />} />
                    <Route path="/hizmetler/yapilandirma-tesvik-ve-hibe-danismanligi" element={<TesvikHibeDanismanlik />} />
                    <Route path="/hizmetler/e-ticaret-satis-muhasebesi" element={<ETicaretSatisMuhasebesi />} />
                    <Route path="/bilgi/mevzuat" element={<Mevzuat />} />
                    <Route path="/bilgi/asgari-ucret" element={<AsgariUcret />} />
                    <Route path="/bilgi/kdv-oranlari" element={<KdvOranlari />} />
                    <Route path="/iletisim" element={<Iletisim />} />
                    <Route path="/haberler/turmob" element={<TurmobNews />} />
                    <Route path="/haberler/gib" element={<GibNews />} />
                </Routes>
            </main>
            <Footer />
        </Router>
    );
}

export default App;
